import { render, staticRenderFns } from "./PayWay.vue?vue&type=template&id=58db27cb&scoped=true&"
import script from "./PayWay.vue?vue&type=script&lang=js&"
export * from "./PayWay.vue?vue&type=script&lang=js&"
import style0 from "./PayWay.vue?vue&type=style&index=0&id=58db27cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db27cb",
  null
  
)

export default component.exports